import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { ReferralPersonalCode as ReferralPersonalCodeBase } from "./ReferralPersonalCode";

export type * from "./ReferralPersonalCode";
export const ReferralPersonalCode = withLoyaltyStore(ReferralPersonalCodeBase, "ReferralPersonalCode");
